import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import RequestDemoSection from "../components/request-demo-section"
import PMPLayout from "../components/index-components/pmp-layout"
import PMPHeader from "../components/index-components/pmp-header"
import CaseStudiesHero from "../components/case-studies/case-studies-hero"
import CaseStudiesList from "../components/case-studies/case-studies-list"
import OutcomeSection from "../components/index-components/outcome-section"

const CaseStudiesPage = ({ data }) => {
  const caseStudies = data.allWordpressAcfCaseStudies.nodes

  return (
    <PMPLayout showNavigation>
      <SEO
        title="inPowered Case Studies"
        description="Learn how brands across various industries are winning with inPowered's AI platform."
      />
      <PMPHeader />
      <CaseStudiesHero />
      <CaseStudiesList caseStudies={caseStudies} />

      <div className="container mt-6 px-5">
        <h2 className="has-text-centered is-size-2 is-size-2-mobile has-text-weight-semibold has-text-purple">
          Explore Solutions
        </h2>
        <div className="mt-5 mb-6">
          <OutcomeSection showDescription={false} />
        </div>
      </div>

      <RequestDemoSection></RequestDemoSection>
    </PMPLayout>
  )
}

export default CaseStudiesPage

export const query = graphql`
  query {
    allWordpressAcfCaseStudies {
      nodes {
        id
        acf {
          slug
          external_url
          brand_logo_1
          brand_logo_2
          brand_logo_3
          custom_post_title
          order
          hero {
            localFile {
              childImageSharp {
                fluid(
                  maxHeight: 600
                  maxWidth: 882
                  quality: 80
                  cropFocus: CENTER
                ) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
